/**
 * Кабинет — после первого ролика (§6, §71).
 *
 * Отзыв первого клиента: «сейчас просто кидает в кабинет, где куча всего,
 * и можно потеряться». Пока первый ролик не получен, разделы не показываем
 * вовсе — человека ведёт коридор на `/start`.
 *
 * Проверка стоит здесь, а не в каждой странице: обойти её, набрав адрес
 * руками, не должно получаться — иначе коридор превращается в подсказку,
 * от которой мы как раз уходим.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { onboardingApi } from '../../api/onboarding';

/**
 * Что открыто внутри коридора: сам коридор и то, куда он ведёт.
 *
 * Страницы образа и ролика нужны шагам коридора, поэтому они открыты —
 * но каркас показывает их без разделов (см. `AppLayout`). Закрыто всё
 * остальное: медиатека, баланс, приглашения, настройки, список проектов.
 */
const ALLOWED = [
  '/start',
  '/persona/capture',
  '/persona/consent',
  '/looks',
  '/create',
  '/projects/',
  '/legal',
];

export function RequireOnboarded() {
  const location = useLocation();

  const onboarding = useQuery({
    queryKey: ['onboarding'],
    queryFn: onboardingApi.get,
    staleTime: 10_000,
  });

  // Пока не знаем — не показываем ничего: мигнуть кабинетом и увести
  // в коридор хуже, чем подождать долю секунды.
  if (onboarding.isPending) return <div className="min-h-full bg-page" />;

  /**
   * Ошибку не превращаем в запрет: сеть моргнула — человек не должен
   * оказаться заперт. Пропускаем в кабинет, коридор вернётся сам.
   */
  if (onboarding.isError || onboarding.data?.completed) return <Outlet />;

  const allowed = ALLOWED.some((path) => location.pathname.startsWith(path));
  return allowed ? <Outlet /> : <Navigate to="/start" replace />;
}
